/**
 * Who wrote a comment, as the reader is shown it.
 *
 * Here rather than beside `MediaCommentsStore` so the sort can use it and still be tested: a
 * store module imports `userStore`, which will not load outside the app. The shape it asks for
 * is the part of `MediaCommentAuthor` it reads, so the store's type satisfies it as is.
 */

type Author = { userId: string; displayName: string };

/**
 * Whether the reader wrote this — which is also whether the API will let them edit or delete it.
 * `currentUserId` null (the session still loading) claims nothing as the reader's.
 */
export const isOwnWriting = (author: Author, currentUserId: string | null): boolean =>
  currentUserId !== null && author.userId === currentUserId;

/**
 * What to call an author where their writing is shown: "You" for the reader's own, their display
 * name otherwise. One function because two surfaces print it — the thread in the panel and the
 * scrub bar's preview — and a note that says "You" in one and "Hugo" in the other reads as two
 * different people.
 */
export const authorLabel = (author: Author, currentUserId: string | null): string =>
  isOwnWriting(author, currentUserId) ? 'You' : author.displayName;
